/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_De_Hosted_LabelInputs */



/**
* | output |
* | --- |
* | "Hosted in Germany" |
*
* @param {Model_De_Hosted_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_de_hosted_label = /** @type {((inputs?: Model_De_Hosted_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_De_Hosted_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("In Deutschland gehostet")
	return /** @type {LocalizedString} */ ("Hosted in Germany")
});